import { AlertTriangle } from "lucide-react";
import type { ReactNode } from "react";

import { cn } from "../../lib/cn";
import { Button } from "./Button";

export interface ErrorStateProps {
  title?: string | undefined;
  message?: string | undefined;
  onRetry?: (() => void) | undefined;
  action?: ReactNode;
  className?: string | undefined;
}

export function ErrorState({
  title = "Something went wrong",
  message,
  onRetry,
  action,
  className,
}: ErrorStateProps) {
  return (
    <div
      role="alert"
      className={cn(
        // #2172 — rises in when it mounts (`motion-state-in`).
        "motion-state-in flex flex-col items-center justify-center rounded-lg border border-danger/30 bg-danger-soft/40 px-6 py-12 text-center",
        className,
      )}
    >
      <div className="mb-3 flex h-10 w-10 items-center justify-center rounded-full bg-danger/15 text-danger">
        <AlertTriangle className="h-5 w-5" aria-hidden="true" />
      </div>
      <p className="text-base font-semibold text-fg">{title}</p>
      {message ? <p className="mt-1 max-w-md text-sm text-fg-muted">{message}</p> : null}
      <div className="mt-4 flex gap-2">
        {onRetry ? (
          <Button variant="secondary" size="sm" onClick={onRetry}>
            Try again
          </Button>
        ) : null}
        {action}
      </div>
    </div>
  );
}
